import { useQuery } from 'react-query';
import { getDashboardSupportRequests } from 'helpers/http/dashboard';

/* This hook will fetch support requests count for sidebar badges */
function useSupportRequestsCount() {
  // Get closures count
  const { data: closuresData, isLoading: isLoadingClosures } = useQuery(
    ['get-support-requests-closures'],
    () =>
      getDashboardSupportRequests({
        page: 1,
        limit: 1000,
        activeTab: 'closures',
        statusFilter: 'active',
      }),
    { keepPreviousData: true }
  );

  // Get disputes count
  const { data: disputesData, isLoading: isLoadingDisputes } = useQuery(
    ['get-support-requests-disputes'],
    () =>
      getDashboardSupportRequests({
        page: 1,
        limit: 1000,
        activeTab: 'dispute',
        statusFilter: 'active',
      }),
    { keepPreviousData: true }
  );

  return {
    closuresCount: closuresData?.data?.length || 0,
    disputesCount: disputesData?.data?.length || 0,
    isLoading: isLoadingClosures || isLoadingDisputes,
  };
}

export default useSupportRequestsCount;
